import styles from './style.module.scss';
import { IProductsServiceItem } from '../../model/products';
import getFormatMessage from '../../locales/get-format-message';
import { getConfig } from '../../config';
import bannerImg from '../../assets/images/products-banner-img.avif';
import rightIcon from '../../assets/svg/right-icon.svg';

interface IProps {
  readonly serviceData: IProductsServiceItem | null;
}

export const ProductsBanner = (props: IProps) => {
  const consoleURL = getConfig()?.consoleURL;

  const handleDocumentationClick = () => {
    if (consoleURL && props.serviceData?.bannerConfig?.docUrl) {
      const url = `${consoleURL}${props.serviceData.bannerConfig.docUrl}`;
      window.open(url, '_blank');
    }
  };

  return (
    <div className={styles.productsBannerBox}>
      <img src={bannerImg} className={styles.bannerImg} />
      <div className={styles.productsBannerContentBox}>
        <div className={styles.bannerName}>
          {props.serviceData?.bannerConfig?.name || ''}
        </div>
        <div className={styles.bannerDesc}>
          {props.serviceData?.bannerConfig?.desc || ''}
        </div>
        <div onClick={handleDocumentationClick} className={styles.bannerDoc}>
          <span>{getFormatMessage('explore_docs')}</span>
          <img src={rightIcon} className={styles.bannerDocRight} />
        </div>
      </div>
    </div>
  );
};
